<template>
  <div class="maintainDetails flex-content">
    <nav-bar class="nav_fixed" :backPath="backPath">
      <i slot="left-icon" class="icon-back public_icon"></i>
      <div slot="center">报修详情</div>
    </nav-bar>
    <div class="container-maintainDetails">
      <div class="maintain-type">
        <div class="top">
          <span
            class="maintain-icon"
            :class="theCssIcon[maintainDetailsInfo.state - 1]"
          ></span>
          <span :style="theStyle[maintainDetailsInfo.state - 1]">
            {{
              maintainDetailsInfo.state !== 4
                ? maintainDetailsInfo.stateName
                  ? maintainDetailsInfo.stateName.slice(-3)
                  : null
                : "已完成"
            }}</span
          >
        </div>
        <div class="bot">
          <span>当前状态：</span>{{ maintainDetailsInfo.stateName }}
        </div>
      </div>
      <div class="maintain-details maintain-section">
        <div class="maintain-title">
          <span class="maintain-title-icon"></span>
          <span maintain-title-con>报修详情</span>
        </div>
        <div class="maintain-type-x">
          <span class="maintain-type-x-title"> 报修类型 </span>
          <span class="maintain-type-x-cont">{{
            maintainDetailsInfo.categoryName
          }}</span>
        </div>
        <div class="maintain-time">
          <span class="maintain-time-title"> 报修时间 </span>
          <span class="maintain-time-cont">
            {{
              maintainDetailsInfo.createTime
                ? maintainDetailsInfo.createTime.substring(
                    0,
                    maintainDetailsInfo.createTime.length - 3
                  )
                : null
            }}
          </span>
        </div>
        <div class="maintain-description">
          <span class="maintain-description-title">损坏描述</span>
          <span class="maintain-description-cont">
            {{ maintainDetailsInfo.content }}
          </span>
        </div>

        <div class="maintain-img">
          <span class="maintain-img-title">损坏物品照片</span>
          <div class="maintain-img-box">
            <div
              class="maintain-list-img"
              :key="index"
              v-for="(imgurl, index) in maintainDetailsInfo.photosList"
              @click="open(index,maintainDetailsInfo.photosList)"
            >
              <img :src="imgurl" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="maintain-details-complete maintain-section" v-if="isMaintain">
        <div class="maintain-title">
          <span class="maintain-title-icon"></span>
          <span maintain-title-con>维修详情</span>
        </div>

        <div class="miantain-details-complete-personTime">
          <div class="miantain-details-complete-person">
            <span class="miantain-details-complete-person-title"> 维修人 </span>
            <span class="miantain-details-complete-person-cont">{{
              maintainDetailsInfo.maintenanceName
            }}</span>
          </div>
          <div class="miantain-details-complete-time">
            <span class="miantain-details-complete-time-title"> 维修时间 </span>
            <span class="miantain-details-complete-time-cont">
              {{
                maintainDetailsInfo.maintenanceTime.substring(
                  0,
                  maintainDetailsInfo.maintenanceTime.length - 3
                )
              }}
            </span>
          </div>
        </div>  

        <div class="maintain-img">
          <span class="maintain-img-title">维修后的照片</span>
          <div class="maintain-img-box">
            <div
              class="maintain-list-img"
              :key="index"
              v-for="(imgurl, index) in maintainDetailsInfo.maintenancePhotosList"
              @click="open(index,maintainDetailsInfo.maintenancePhotosList)"
            >
              <img :src="imgurl" alt="" />
            </div>
          </div>
        </div>

      </div>

      <div class="maintain-appraise maintain-section" v-if="isAppraise">
        <div class="maintain-title">
          <span class="maintain-title-icon"></span>
          <span maintain-title-con>维修评价</span>
        </div>
        <div class="maintain-appraise-score">
          <span class="miantain-appraise-score-title"> 维修评分 </span>
          <span class="miantain-appraise-score-con">
            <van-rate
              v-model="maintainDetailsInfo.score"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
              readonly
            />
          </span>
        </div>
        <div class="maintain-appraise">
          <span class="maintain-appraise-title">评价内容</span>
          <span class="maintain-appraise-cont">
            {{ maintainDetailsInfo.evaluationNote }}
          </span>
        </div>
      </div>
    </div>
    <Foot class="Foot"></Foot>
  </div>
</template>

<script>
import Foot from "../../components/Foot.vue"
import NavBar from "components/common/NavBar";
import { getMaintainDetails } from "network/maintainRecord";
import { ImagePreview } from "vant";
export default {
  name: "MaintainDetails",
  components: {
    NavBar,
    Foot
  },
  data() {
    return {
      backPath: "/maintainRecord",
      theStyle: [
        //报修状态颜色
        {
          color: "#6ba0fe",
        },
        {
          color: "#f06979",
        },
        {
          color: "#fbb94b",
        },
        {
          color: "#323233",
        },
      ],
      theCssIcon: [
        //报修图标位置
        "maintain-icon-a",
        "maintain-icon-b",
        "maintain-icon-c",
        "maintain-icon-d",
      ],
      maintainDetailsInfo: [],
      isMaintain: false,
      isAppraise: false,
    };
  },
  created() {
    this.$loading.show("");
    let maintainDetailsId = location.search.slice(4);
    getMaintainDetails(maintainDetailsId)
      .then((result) => {
        if (result.code === 1) {
          this.$loading.hide();
          this.maintainDetailsInfo = result.result;
          //维修详情
          if (
            this.maintainDetailsInfo.state === 3 ||
            this.maintainDetailsInfo.state === 4
          ) {
            this.isMaintain = true;
          }
          //维修评价
          if (this.maintainDetailsInfo.state === 4) {
            this.isAppraise = true;
          }
        }
      })
      .catch((err) => {});
  },
  mounted() {},
  methods: {
    //图片放大
    open(index,imglist) {
      ImagePreview({
        images: imglist,
        startPosition: index,
      });
    },
  },
};
</script>

<style scoped src='./MaintainDetails.css'>
</style>